export default {
  club_name: 'Åsane Fotball',
  club_name_short: 'asane',
  stadium_name: '',
  staging_url: 'https://asane.api.fangroup.io',
  prod_url: 'https://asane.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/asane',
  club_logo: '/assets/teams/asane.png',
  app_name: 'asane',
  websale_name: 'asane',
  ntb_team_id: 10069,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'NOK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'asane',
  monolithEnabled: false,
  clubWebsiteEnabled: false,
};
